/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Form, Segment, Divider, Checkbox, Grid, Input } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

class Diagnostic extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      selectedItemAddress: -1,
      devices: [],
      dropdownOptions: [],
      formInputTag: "",
      diagnostic1: "",
      diagnostic2: "",
      diagnostic3: "",
      diagnostic4: "",
      diagnostic5: "",
      diagnostic6: "",
      diagnostic7: "",
      diagnostic8: "",
      binAtivo1: false,
      binAtivo2: false,
      binAtivo3: false,
      binAtivo4: false,
      binAtivo5: false,
      binAtivo6: false,
      binAtivo7: false,
      binAtivo8: false,
      ativo: false,
      byteDiagnostico: [],
      binarioDiagnostico: "",
      isInAutomaticBlacklistList: [],
    };
  }

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "diagnostico", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy("address", false, parseInt))
      }, () => {
        this.buildDropdownOptionsList();
      }));
  }

  buildDropdownOptionsList = () => {
    let dropdownOptionsList = [];

    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].status === Constants.MASTER) {
        dropdownOptionsList.push({
          key: this.state.devices[i].address,
          value: this.state.devices[i].address,
          text: "Mestre #" + this.state.devices[i].address
        });
      }
      else {
        dropdownOptionsList.push({
          key: this.state.devices[i].address,
          value: this.state.devices[i].address,
          text: "Device #" + this.state.devices[i].address
        });
      }
    }

    this.setState({ dropdownOptions: dropdownOptionsList });
  }

    // When a dropdown option is selected, save the PROFIBUS address of the device on the state
  // So we can use it later to send to the server
  handleDropwdownItemClick = (event, info) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].address === info.value) {
        let binarioDiagnostico = "";
        let byteDiagnostico = [];
        let ativo = false;
        let binValue1 = false;
        let stringValue1 = "";
        let binValue2 = false;
        let stringValue2 = "";
        let binValue3 = false;
        let stringValue3 = "";
        let binValue4 = false;
        let stringValue4 = "";
        let binValue5 = false;
        let stringValue5 = "";
        let binValue6 = false;
        let stringValue6 = "";
        let binValue7 = false;
        let stringValue7 = "";
        let binValue8 = false;
        let stringValue8 = "";

        if (this.state.devices[i].binarioDiagnostico !== null) {
          binarioDiagnostico = this.state.devices[i].binarioDiagnostico;
        }

        if (this.state.devices[i].byteDiagnostico !== null) {
          byteDiagnostico = this.state.devices[i].byteDiagnostico;

          Object.keys(byteDiagnostico).forEach((key) => {
            const binKey = `diagAtivo`;
            const stringKey = `stringDiagnostico`;
            const binValueaux = byteDiagnostico[key][binKey] !== undefined ? byteDiagnostico[key][binKey].toString() : "-";
            const binValue = binValueaux === "true";
            const stringValue = byteDiagnostico[key][stringKey] || "-";

            key = parseInt(key,10)

            if (key === 0){
              binValue1 = binValue
              stringValue1 = stringValue
            }
            else if (key === 1){
              binValue2 = binValue
              stringValue2 = stringValue
            }
            else if (key === 2){
              binValue3 = binValue
              stringValue3 = stringValue
            }
            else if (key === 3){
              binValue4 = binValue
              stringValue4 = stringValue
            }
            else if (key === 4){
              binValue5 = binValue
              stringValue5 = stringValue
            }
            else if (key === 5){
              binValue6 = binValue
              stringValue6 = stringValue
            }
            else if (key === 6){
              binValue7 = binValue
              stringValue7 = stringValue
            }
            else if (key === 7){
              binValue8 = binValue
              stringValue8 = stringValue
            }
          })
        }

        if (this.state.devices[i].ativo !== null) {
          ativo = this.state.devices[i].ativo;
        }

        this.setState({
          selectedItemAddress: this.state.devices[i].address,
          ativo: ativo,
          binarioDiagnostico: binarioDiagnostico,
          binAtivo1: binValue1,
          binAtivo2: binValue2,
          binAtivo3: binValue3,
          binAtivo4: binValue4,
          binAtivo5: binValue5,
          binAtivo6: binValue6,
          binAtivo7: binValue7,
          binAtivo8: binValue8,
          diagnostic1: stringValue1,
          diagnostic2: stringValue2,
          diagnostic3: stringValue3,
          diagnostic4: stringValue4,
          diagnostic5: stringValue5,
          diagnostic6: stringValue6,
          diagnostic7: stringValue7,
          diagnostic8: stringValue8
        });

        break;
      }
    }
  }

  handleSubmit = () => {
    let newTagInfo = {};

    // Save the device address and new tag to be modified
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].address === this.state.selectedItemAddress) {
        newTagInfo.address = this.state.selectedItemAddress;
        newTagInfo.ativo = this.state.ativo;
        newTagInfo.binarioDiagnostico = this.state.binarioDiagnostico;
        newTagInfo.binAtivo1 = this.state.binAtivo1;
        newTagInfo.binAtivo2 = this.state.binAtivo2;
        newTagInfo.binAtivo3 = this.state.binAtivo3;
        newTagInfo.binAtivo4 = this.state.binAtivo4;
        newTagInfo.binAtivo5 = this.state.binAtivo5;
        newTagInfo.binAtivo6 = this.state.binAtivo6;
        newTagInfo.binAtivo7 = this.state.binAtivo7;
        newTagInfo.binAtivo8 = this.state.binAtivo8;
        newTagInfo.diagnostic1 = this.state.diagnostic1;
        newTagInfo.diagnostic2 = this.state.diagnostic2;
        newTagInfo.diagnostic3 = this.state.diagnostic3;
        newTagInfo.diagnostic4 = this.state.diagnostic4;
        newTagInfo.diagnostic5 = this.state.diagnostic5;
        newTagInfo.diagnostic6 = this.state.diagnostic6;
        newTagInfo.diagnostic7 = this.state.diagnostic7;
        newTagInfo.diagnostic8 = this.state.diagnostic8;
        newTagInfo.srcAddress = this.state.devices[i].srcAddress
        break;
      }
    }

    let data = JSON.stringify(newTagInfo);

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "setDiagnostico", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.DIAG_SUCcESS_MSG);
        // After changing the tag, get the new data
        this.retrieveData();
      })
      .catch((error) => {
        alert(Strings.REMOVE_DIAG_FAILURE + Strings.REASON + error);
      });
  }

  onChangeTagInput = (e, data) => {
    if (data.value.length <= 20) {
      this.setState({
        formInputTag: data.value
      });
    }
  }

  handleDiagnostic1Change = (e, { value }) => {
    this.setState({ diagnostic1: value });
  }

  handleDiagnostic2Change = (e, { value }) => {
    this.setState({ diagnostic2: value });
  }

  handleDiagnostic3Change = (e, { value }) => {
    this.setState({ diagnostic3: value });
  }

  handleDiagnostic4Change = (e, { value }) => {
    this.setState({ diagnostic4: value });
  }

  handleDiagnostic5Change = (e, { value }) => {
    this.setState({ diagnostic5: value });
  }

  handleDiagnostic6Change = (e, { value }) => {
    this.setState({ diagnostic6: value });
  }

  handleDiagnostic7Change = (e, { value }) => {
    this.setState({ diagnostic7: value });
  }

  handleDiagnostic8Change = (e, { value }) => {
    this.setState({ diagnostic8: value });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  // ------ Toggle Checkboxes ---------
  toggleCheckboxbin = () => {
    let ativ = this.state.ativo
    this.setState({ ativo: !ativ });
  }
  toggleCheckboxbin1 = () => {
    let binAtivo = this.state.binAtivo1
    this.setState({ binAtivo1: !binAtivo });
  }
  toggleCheckboxbin2 = () => {
    let binAtivo = this.state.binAtivo2
    this.setState({ binAtivo2: !binAtivo });
  }
  toggleCheckboxbin3 = () => {
    let binAtivo = this.state.binAtivo3
    this.setState({ binAtivo3: !binAtivo });
  }
  toggleCheckboxbin4 = () => {
    let binAtivo = this.state.binAtivo4
    this.setState({ binAtivo4: !binAtivo });
  }
  toggleCheckboxbin5 = () => {
    let binAtivo = this.state.binAtivo5
    this.setState({ binAtivo5: !binAtivo });
  }
  toggleCheckboxbin6 = () => {
    let binAtivo = this.state.binAtivo6
    this.setState({ binAtivo6: !binAtivo });
  }
  toggleCheckboxbin7 = () => {
    let binAtivo = this.state.binAtivo7
    this.setState({ binAtivo7: !binAtivo });
  }
  toggleCheckboxbin8 = () => {
    let binAtivo = this.state.binAtivo8
    this.setState({ binAtivo8: !binAtivo });
  }

  render() {
    return (
      <Grid style={divStyle} columns={1} doubling verticalAlign="middle">

        <Grid.Column>
          <Segment>
            <Divider horizontal>{Strings.DISP_DIAG}</Divider>
            <Form onSubmit={this.handleSubmit}>
              <Form.Dropdown
                placeholder={Strings.CHOOSE_DEVICE}
                fluid
                lazyLoad
                search
                clearable
                selection
                scrolling
                options={this.state.dropdownOptions}
                onChange={this.handleDropwdownItemClick}
              />

            <Divider horizontal>{Strings.DIAGNOSTIC_BYTE}</Divider>
            <Form.Field inline>
                <Input
                    readOnly
                    style={inputStyle2}
                    placeholder={Strings.DATA_FIELD_PLACEHODLER}
                    value={this.state.binarioDiagnostico} />
            </Form.Field>
            <Segment>
                <Divider horizontal>{Strings.DIAGNOSTIC_LIST}</Divider>

                <Checkbox
                    label={Strings.ENABLE_DIAGNOSTIC}
                    checked={this.state.ativo}
                    onChange={() => { this.toggleCheckboxbin(); }}
                />

                <Form.Field inline>
                    <label >{Strings.BIT1}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic1}
                        placeholder={Strings.DIAGNOSTIC1}
                        onChange={this.handleDiagnostic1Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "1"}
                        checked={this.state.binAtivo1}
                        onChange={() => { this.toggleCheckboxbin1(); }}
                    />
                </Form.Field>
                
                <Form.Field inline>
                    <label >{Strings.BIT2}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic2}
                        placeholder={Strings.DIAGNOSTIC2}
                        onChange={this.handleDiagnostic2Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "2"}
                        checked={this.state.binAtivo2}
                        onChange={() => { this.toggleCheckboxbin2(); }}
                    />
                </Form.Field>

                <Form.Field inline>
                    <label >{Strings.BIT3}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic3}
                        placeholder={Strings.DIAGNOSTIC3}
                        onChange={this.handleDiagnostic3Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "3"}
                        checked={this.state.binAtivo3}
                        onChange={() => { this.toggleCheckboxbin3(); }}
                    />
                </Form.Field>

                <Form.Field inline>
                    <label >{Strings.BIT4}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic4}
                        placeholder={Strings.DIAGNOSTIC4}
                        onChange={this.handleDiagnostic4Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "4"}
                        checked={this.state.binAtivo4}
                        onChange={() => { this.toggleCheckboxbin4(); }}
                    />
                </Form.Field>

                <Form.Field inline>
                    <label >{Strings.BIT5}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic5}
                        placeholder={Strings.DIAGNOSTIC5}
                        onChange={this.handleDiagnostic5Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "5"}
                        checked={this.state.binAtivo5}
                        onChange={() => { this.toggleCheckboxbin5(); }}
                    />
                </Form.Field>
                
                <Form.Field inline>
                    <label >{Strings.BIT6}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic6}
                        placeholder={Strings.DIAGNOSTIC6}
                        onChange={this.handleDiagnostic6Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "6"}
                        checked={this.state.binAtivo6}
                        onChange={() => { this.toggleCheckboxbin6(); }}
                    />
                </Form.Field>

                <Form.Field inline>
                    <label >{Strings.BIT7}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic7}
                        placeholder={Strings.DIAGNOSTIC7}
                        onChange={this.handleDiagnostic7Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "7"}
                        checked={this.state.binAtivo7}
                        onChange={() => { this.toggleCheckboxbin7(); }}
                    />
                </Form.Field>

                <Form.Field inline>
                    <label >{Strings.BIT8}</label>
                    <Input
                        style={inputStyle}
                        value={this.state.diagnostic8}
                        placeholder={Strings.DIAGNOSTIC8}
                        onChange={this.handleDiagnostic8Change} />
                    <Checkbox
                        style={{ marginLeft: "40px" }} 
                        label={Strings.ENABLE_DIAGNOSTIC_BIT + "8"}
                        checked={this.state.binAtivo8}
                        onChange={() => { this.toggleCheckboxbin8(); }}
                    />
                </Form.Field>

                <Form.Button color="teal">{Strings.SAVE}</Form.Button>
            </Segment>
            </Form>
          </Segment>
        </Grid.Column>

      </Grid>
    );
  }
}

const divStyle = {
  margin: "0 auto",
  textAlign: "center"
};

// const labelStyle = {
//     width: "20%"
//   };
  
  const inputStyle = {
    width: "60%"
  };
  const inputStyle2 = {
    width: "100%"
  };

export default Diagnostic;
